'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import {
  PickleballFeatureCard,
  PickleballFeatureCardData,
} from './pickleball-feature-card'

interface Props {
  title: string
  items: PickleballFeatureCardData[]
}

export const PickleballShowcaseSection = ({ title, items }: Props) => {
  const isMobile = useIsMobileClient()

  return (
    <CollectionContainer>
      <h3 className='mb-4 font-criteria text-2xl font-medium uppercase text-neutral-900 lg:text-[28px] lg:leading-10'>
        {title}
      </h3>

      <Carousel
        opts={{
          align: 'start',
          loop: true,
          skipSnaps: false,
          slidesToScroll: 1,
        }}
        className='w-full'
      >
        <CarouselContent className='-ml-4'>
          {items.map((item, index) => (
            <CarouselItem
              key={index}
              className={isMobile ? 'basis-[80%] pl-4' : 'basis-1/4 pl-4'}
            >
              <PickleballFeatureCard {...item} />
            </CarouselItem>
          ))}
        </CarouselContent>

        {!isMobile && (
          <>
            <CarouselPrevious
              className='absolute -left-5 top-1/2 h-9 w-9 -translate-y-1/2 rounded-full bg-black p-2 text-white'
              variant='outline'
              hideIfStart
            />
            <CarouselNext
              className='absolute -right-5 top-1/2 h-9 w-9 -translate-y-1/2 rounded-full bg-black p-2 text-white'
              variant='outline'
              hideIfEnd
            />
          </>
        )}
      </Carousel>
    </CollectionContainer>
  )
}
